import BlockRegistry from '../../BlockRegistry';

export function registerPIRSensor() {
    BlockRegistry.register('pirSensor_pir_motionDetected', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        context.addSetup(`pinMode(${pin}, INPUT);`);
        return `(digitalRead(${pin}) == HIGH)`;
    });

    BlockRegistry.register('pirSensor_pir_waitMotion', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        context.addSetup(`pinMode(${pin}, INPUT);`);
        return `while (digitalRead(${pin}) == LOW) { delay(10); }`;
    });
}
